export default "__VITE_ASSET__b3e9beae__"